<template>
    <div class=" col-5 form-group col-customer_message"
        style="display: flex;flex-direction: column;justify-content: flex-start;margin-bottom: 0;">
        <label for="customer_message">Customer Message <small>(Optional)</small></label>
        <!--
        <textarea id="customer_message"
            :class="['form-control customer_message', (disabledState) ? 'disabled' : '']"
            :disabled="disabledState" v-model="customer_message"
            @change="setUpdate"
            placeholder="We hope to continue doing business with you." maxlength="300"></textarea>
        <span class="maxSize">
            {{ (customer_message != null) ? customer_message.length : 0 }}/300
        </span>
        -->
        <editor-customer-message :value="customer_message" :limit="numberWords" :limitType="'words'"
            :placeholder="'We hope to continue doing business with you.'" :readonly="disabledState"
            :editorClass="'form-control customer_message '" @input="setUpdate"
            :emitOnLimitReached="true"></editor-customer-message>
    </div>
</template>
<script>
import RichTextEditor from './../../RichTextEditor.vue'
export default {
    props: [
        "controlLoad",
        "propForm",
        "propdisabledSteps",
    ],
    components: {
        "editor-customer-message": RichTextEditor,
    },
    data() {
        return {
            customer_message: this.propForm?.customer_message || null,
            disabledState: this.propdisabledSteps?.customer || false,
            numberWords: 50,
        };
    },
    mounted() {
        this.getKeyValSetting('customer_message_numberWords', 50).then((resul) => {
            this.numberWords = parseInt(resul);
        });
    },
    methods: {
        setUpdate(data) {
            // console.log('event change setUpdate customer_message', data)
            data = (data == null || data == undefined) ? this.customer_message : data;
            data = (typeof data == 'string') ? data : "";
            this.$emit('updateProps', data);
        },
        getKeyValSetting (meta_key, valueDefault) {
            return new Promise((resolve, reject) => {
                try{
                    window.apiv2
                    .post('getKeyValSetting', {
                        user_id: window.master_client,
                        org_id: window.localorgdata,
                        meta_key: meta_key,
                    })
                    .then((response) => {
                        // console.log(meta_key, response.data);
                        resolve(response.data.status ? response?.data?.r?.meta_value : valueDefault);
                    });
                }catch(e){
                    resolve(valueDefault);
                    reject(valueDefault);
                }
            });
        },
    }
};
</script>
<style>
.form-control.customer_message,
.quillWrapper.form-control.customer_message {}

.quillWrapper.form-control.customer_message .ql-editor li:not(.ql-direction-rtl)::before {
    left: -5px !important;
}
</style>
